
var id = "numberDown";
var markup = "<symbol viewBox=\"0 0 8 13\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"numberDown\">\n    <title>Path</title>\n    <g id=\"numberDown_Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"numberDown_品牌健康中心-新-copy\" transform=\"translate(-966.000000, -380.000000)\" fill=\"#FF9800\" fill-rule=\"nonzero\">\n            <g id=\"numberDown_Total-Sales---ALL\" transform=\"translate(304.000000, 258.000000)\">\n                <g id=\"numberDown_Total-Sales\" transform=\"translate(40.000000, 40.000000)\">\n                    <g id=\"numberDown_Total-Sales---data\" transform=\"translate(0.000000, -0.000000)\">\n                        <g id=\"numberDown_Group-22\" transform=\"translate(522.000000, 73.000000)\">\n                            <g id=\"numberDown_shangshengjiantouicon1x\" transform=\"translate(100.000000, 9.500000)\">\n                                <path d=\"M7.64848485,6.82727273 L3.82424242,12 L0,6.82727273 L1.69545455,6.82727273 C1.71212121,6.67575758 1.73181818,6.51969697 1.75909091,6.35606061 C2.34545455,2.59242424 4.42575758,0.474242424 8,0 C6.41818182,2.25757576 5.6,4.45757576 5.54545455,6.59848485 L5.54242424,6.82727273 L7.64848485,6.82727273 Z\" id=\"numberDown_Path\" />\n                            </g>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
